module.exports = __webpack_public_path__ + "img/Brainforce.3898d764.png";